/**
 * KİMLİK DEĞİŞİNCE SAYFA TEMİZ YÜKLENİR — «Kullanıcı değiştir» ve «Kendi hesabıma dön» (19 Ekim 2026).
 *
 * Eskiden geçiş açık sayfanın içinde yapılıyordu: oturum sorgusu tazeleniyor, `AuthProvider` önbellekteki
 * her şeyi siliyor, açık ekranlar yeni kimlikle aynı anda yeniden çekiyor ve hemen ardından `/my-panel`'e
 * gidiliyordu. Ölçüm (Chromium, yerel): geçişten sonraki 6 saniyede 35 istek. Bu ağır yeniden çizim,
 * «Kullanıcı değiştir» penceresinin kapanış animasyonuyla aynı ana düşüyor; Safari'de bu sırada sayfa
 * donuyor ve kenar çubuğuna tıklanamıyordu (kullanıcı bildirimi). Pencere katmanı kapanışını
 * tamamlayamazsa gövde «tıklanamaz» kipinde kalır — tarayıcıya ve zamanlamaya bağlı bir durum.
 *
 * Tam yükleme hepsini birden çözüyor: önceki kimliğin bellekte kalan hiçbir verisi, açık penceresi ya da
 * canlı bağlantısı yeni kimliğe taşınmaz; uygulama yeni çerezle sıfırdan açılır. Bedeli tek bir yükleme.
 * `replace`: geri tuşu önceki kimliğin ekranına dönmesin.
 */
export function reloadIntoIdentity(path = "/my-panel"): void {
  window.location.replace(path);
}
